/* eslint-disable */
import React from 'react'
import FaAngleLeft from 'react-icons/lib/fa/angle-left'
import FaCalendar from 'react-icons/lib/fa/calendar'
import moment from 'moment'
import FaAngleRight from 'react-icons/lib/fa/angle-right'
import { object, func } from 'prop-types'
import styles from './Calendar.styl'
const translateMonth = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

export default class Calendar extends React.Component {

	static propTypes = {
		value: object,
		handleDateChange: func,
		clicky: func
	}

	constructor(props) {
		super(props)
		const month = props.value.month()
		const year = props.value.year()

		this.state = {
			open: !this.isMobile(),
			day: props.value.date(),
			month,
			year,
			days: this.createArray(month, year),
			clicky: this.isMobile()
		}
		this.goBack = this.goBack.bind(this)
		this.goForth = this.goForth.bind(this)
	}

	componentWillReceiveProps(nextProps) {
		const day = nextProps.value.date()
		const month = nextProps.value.month()
		const year = nextProps.value.year()
		this.setState(prevState => ({ month, year, day, days: prevState.month !== month ? this.createArray(month, year, nextProps) : prevState.days }))
	}

	isMobile() {
		if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
			let check = false;
			(function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) { check = true } }(navigator.userAgent || navigator.vendor || window.opera))
			return check
		}
		return false
	}

	createArray(month, year, nextProps) {
		const { value } = nextProps || this.props
		const beginOfMonth = this.calcDay(1, month + 1, year)
		const daysThisMonth = this.monthDays(month.toString(), year)
		const dayLastMonth = this.monthDays((month - 1 >= 0 ? month - 1 : 11).toString(), year)

		const daysArray = []
		for (let x = 1; x <= daysThisMonth; x++) {
			daysArray.push({
				day: x,
				style: styles.current,
				action: this.changeDay.bind(this)
			})
		}
		for (let z = dayLastMonth; z > dayLastMonth - beginOfMonth; z--) {
			daysArray.unshift({
				day: z,
				style: styles.other,
				action: this.goBack.bind(this)
			})
		}
		if (daysArray.length !== 7 * 6) {
			const filledDays = daysArray.length
			for (let y = 0; y < 7 * 6 - filledDays; y++) {
				daysArray.push({
					day: y + 1,
					style: styles.other,
					action: this.goForth.bind(this)
				})
			}
		}
		return daysArray
	}

	calcDay(day, month, year) {
		const a = Math.floor((14 - month) / 12)
		const y = year - a
		const m = month + 12 * a - 2
		let d = ((day + y + Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(year / 400) + Math.floor((31 * m) / 12)) % 7) - 1
		if (d < 0) { d = 6 }
		return d
	}

	monthDays(month, year) {
		if (month.match(/^0|2|4|6|7|9|11/)) { return 31 } else if (month.match(/3|5|8|10/)) { return 30 } else if (year % 4 !== 0) { return 28 } else if (year % 100 !== 0 || year % 400 === 0) { return 29 } else { return 28 }
	}

	goBack(day) {
		const { month, year } = this.state
		let newYear = year
		let newMonth = month - 1
		if (newMonth < 0) {
			newYear = year - 1
			newMonth = 11
		}
		this.props.handleDateChange(moment.utc([newYear, newMonth, day]))
	}

	goForth(day) {
		const { month, year } = this.state
		let newYear = year
		let newMonth = month + 1
		if (newMonth > 11) {
			newYear = year + 1
			newMonth = 0
		}
		this.props.handleDateChange(moment.utc([newYear, newMonth, day]))
	}

	changeDay(day) {
		const { month, year } = this.state
		this.props.handleDateChange(moment.utc([year, month, day]))
	}

	goBackArrow() {
		this.setState(prevState => {
			const newDate = prevState.month - 1 < 0 ? { month: 11, year: prevState.year - 1 } : { month: prevState.month - 1, year: prevState.year }
			return { ...newDate, days: this.createArray(newDate.month, newDate.year) }
		})
	}
	goForthArrow() {
		this.setState(prevState => {
			const newDate = prevState.month + 1 > 11 ? { month: 0, year: prevState.year + 1 } : { month: prevState.month + 1, year: prevState.year }
			return { ...newDate, days: this.createArray(newDate.month, newDate.year) }
		})
	}
	constructCalendar() {
		const { days, month, year } = this.state
		const { value } = this.props
		const tbody = []
		const tableCells = days.map((ele, index) => {
			const today = (ele.day === value.date() && month === value.month() && year === value.year())
			return (
				<td
					key={ index }
					onClick={ () => { ele.action(ele.day) } }
					className={ today && ele.style === styles.current ? styles.currentSelected : ele.style }
				>
					{ ele.day }
				</td>)
		})
		for (let i = 0; i < 6; i++) {
			tbody.push(<tr key={ i } className={ styles.nameRow }>{ tableCells.slice(i * 7, i * 7 + 7) }</tr>)
		}
		return tbody
	}

	render() {
		const { month, year, open, clicky } = this.state
		return (
			<div className={ styles.calendar }>
				<div
					className={ styles.iconTitle } onClick={ () => {
						if (clicky) { this.setState(prevState => ({ open: !prevState.open })) }
					} }
				>
					<FaCalendar />
					<div>
						<p>Calendário</p>
						<p>{ year }</p>
					</div>
				</div>
				{ open ?
					<div>
						<div className={ styles.calendarTitle }>
							<div onClick={ () => { this.goBackArrow() } }><FaAngleLeft color="#eb6800" /></div>
							<h3>{ translateMonth[month] }</h3>
							<div onClick={ () => { this.goForthArrow() } }><FaAngleRight color="#eb6800" /></div>
						</div>
						<table>
							<thead>
								<tr className={ styles.nameRow }>
									<td>SEG</td>
									<td>TER</td>
									<td>QUA</td>
									<td>QUI</td>
									<td>SEX</td>
									<td>SÁB</td>
									<td>DOM</td>
								</tr>
							</thead>
							<tbody>
								{ this.constructCalendar() }
							</tbody>
						</table> </div> : null }
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/Calendar/Calendar.js